import Swiper from 'swiper/bundle';

  document.addEventListener("DOMContentLoaded", function () {
    function sliderWithContent(){
      const galleryThumbs = new Swiper(".gallery-thumbs", {
        spaceBetween: 26,
        slidesPerView: 3,
        freeMode: false,
        watchSlidesProgress: true,
        allowTouchMove: false,
      });

      // large image swiper slider 
      const imageSwiper = new Swiper(".image-slider", {
        mousewheel: false,
        speed: 1000,
        loop: false,
        thumbs: {
          swiper: galleryThumbs,
        },
      });

    }
    sliderWithContent();
});
